<template>
  <div v-if="checkVersion">
    <div>
      <b-row class="component-margin">
        <b-col class="zoom-back-1" sm="1">
          <date-picker id="startDate" :value="startDate" @change="updateStartDate($event)"/>
        </b-col>
        <b-col class="zoom-back-1" sm="1">
          <date-picker id="endDate" :value="endDate" @change="updateEndDate($event)"/>
        </b-col>
        <b-col sm="1">
          <b-input v-model="nameFilter" size="sm" placeholder="会員番号"/>
        </b-col>
        <b-col sm="3">
          <b-btn size="sm" @click="outputCsv(null)" variant="danger">ファイル出力</b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="filteredItems" :fields="fields"
                  :current-page="currentPage" :per-page="perPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                  <template slot="customBillingDate" slot-scope="row">
                    <label>{{formatDate(row.value)}}</label>
                  </template>
                  <template slot="createDate" slot-scope="row">
                    <label>{{formatDate(row.value)}}</label>
                  </template>
                  <template slot="customs" slot-scope="row">
                    <label>{{formatPrice(row.value)}}</label>
                  </template>
                  <template slot="lasRegisteredDate" slot-scope="row">
                    <label>{{formatDate(row.value)}}</label>
                  </template>
                  <template slot="update" slot-scope="row">
                    <b-button size="sm" @click="editModal(row)" variant="warning">更新</b-button>
                  </template>
                  <template slot="delete" slot-scope="row">
                    <b-button size="sm" @click="dispDeletePopup(row)" variant="danger">削除</b-button>
                  </template>
          </b-table>
          <b-modal ref="editModal" title="関税変更" @ok="updateCustom" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
            <b-form-group size="sm" horizontal label="請求日" label-class="text-sm-right" label-for="customBillingDate">
              <date-picker id="customBillingDate" class="table-linput" :value="editItem.customBillingDate" @change="($event) => editItem.customBillingDate = $event"/>
            </b-form-group>
            <b-form-group size="sm" horizontal label="請求額" label-class="text-sm-right" label-for="customs">
              <b-form-input size="sm" id="customs" v-model="editItem.customs" type="text"/>
            </b-form-group>
            <b-form-group size="sm" horizontal label="追跡番号" label-class="text-sm-right" label-for="trackingNumber">
              <b-form-input size="sm" id="trackingNumber" v-model="editItem.trackingNumber" type="text"/>
            </b-form-group>
            <b-form-group size="sm" horizontal label="LAS登録日" label-class="text-sm-right" label-for="lasRegisteredDate">
              <date-picker id="customBillingDate" class="table-linput"  :addclearbtn=true :notinitdate=true :value="editItem.lasRegisteredDate" @change="($event) => editItem.lasRegisteredDate = $event"/>
              <!-- <date-picker id="receiptDate" class="table-linput" :addclearbtn=true :notinitdate=true :value="editItem.receiptDate" @change="($event) => editItem.receiptDate = $event"/> -->
            </b-form-group>
          </b-modal>
          <b-modal ref="messagePopupSimple" ok-only hide-header>
            <div class="text-center">{{confirmMessageSimple}}</div>
          </b-modal>
          <b-modal ref="messagePopupForDelete" @ok="deleteCustom" hide-header>
            <div class="text-center">{{confirmMessageSimple}}</div>
          </b-modal>
          <!-- <div md="6">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
          </div> -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import InboundSlcAnalysis from '@/components/inbound/InboundSlcAnalysis';
import DatePicker from '@/components/common/DatePicker';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    version: {
      default: 1,
    },
    isUpdate: {
      default: false,
    },
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'customBillingDate', label: '請求日', sortable: true, variant: 'base', class: 'table-lw6' },
        { key: 'customs', label: '請求額', sortable: true, variant: 'base', class: 'table-lw6' },
        { key: 'trackingNumber', label: '追跡番号', sortable: true, variant: 'base', class: 'table-lw6' },
        { key: 'lasRegisteredDate', label: 'LAS登録日', sortable: true, variant: 'base', class: 'table-lw6' },
        { key: 'memberId', label: '会員番号', sortable: true, variant: 'warning', class: 'table-lw6' },
        { key: 'name', label: '会員名', sortable: true, variant: 'warning', class: 'table-lw6' },
        { key: 'createDate', label: '登録日', sortable: true, variant: 'warning', class: 'table-lw6' },
        { key: 'update', label: '更新', sortable: true, variant: 'success', class: 'table-lw6' },
        { key: 'delete', label: '削除', sortable: true, variant: 'success', class: 'table-lw6' },
      ],
      slcAnalysisItems: [],
      editItem: {},
      confirmMessageSimple: '',
      nameFilter: '',
      // currentPage: 1,
      // perPage: 100,
      // totalRows: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      startDate: '',
      endDate: ''
    };
  },
  created() {
    var dtEnd = new Date();
    var dtStart = new Date();
    dtStart.setDate(dtStart.getDate()-30);

    var y = dtStart.getFullYear();
    var m = ('00' + (dtStart.getMonth()+1)).slice(-2);
    var d = ('00' + dtStart.getDate()).slice(-2);
    if(this.startDate === '') {
      this.startDate = y + m + d;
    }

    var y = dtEnd.getFullYear();
    var m = ('00' + (dtEnd.getMonth()+1)).slice(-2);
    var d = ('00' + dtEnd.getDate()).slice(-2);
    if(this.endDate === '') {
      this.endDate = y + m + d;
    }
  },
  computed: {
    filteredItems() {
      // SLC担当かつ初回のみ登録される。
      let filteredItems = this.items.filter(item => {
          return ((item.customBillingDate >= this.startDate && item.customBillingDate <= this.endDate) && (this.nameFilter === '' || this.nameFilter === item.memberId));
        });
      return filteredItems;
    },
    checkVersion() {
      // SLC担当の場合
      if(this.version !== 1 && this.isUpdate){
        this.isUpdate = false;
        this.callApi();
      }
      return true;
    },
  },
  methods: {
    updateStartDate($event) {
      this.startDate = $event;
      // this.callApi();
    },
    updateEndDate($event) {
      this.endDate = $event;
      // this.callApi();
    },
    callApi() {
      api.getCustomAll((data) => {
        this.items = data.customAllList;
        this.addCellVariant(this.items);
      });
    },
    editModal(row) {
      this.editItem =  Object.assign({}, this.editItem , row.item);
      // Object.assign(this.editItem , row.item);
      this.$refs.editModal.show();
    },
    dispDeletePopup(row) {
      this.editItem =  Object.assign({}, this.editItem , row.item);
      this.confirmMessageSimple = '登録を削除します。';
      this.$refs.messagePopupForDelete.show();
    },
    updateCustom() {
      api.updateCustom(this.editItem, (data) => {
        this.items = data.customAllList;
        this.addCellVariant(this.items);
        this.confirmMessageSimple = '登録内容を変更しました。';
        this.$refs.messagePopupSimple.show();
      })
    },
    deleteCustom() {
      api.deleteCustom(this.editItem, (data) => {
        this.items = data.customAllList;
        this.addCellVariant(this.items);
        this.confirmMessageSimple = '登録を削除しました。';
        this.$refs.messagePopupSimple.show();
      })
    },
    addCellVariant(items) {
      this.hasErrors = false;
      for (const v of items) {
        const errorCells = [];
        if (v['name'] === '-') {
          errorCells['memberId'] = 'danger';
          errorCells['name'] = 'danger';
          errorCells['customBillingDate'] = 'danger';
          errorCells['customs'] = 'danger';
          errorCells['lasRegisteredDate'] = 'danger';
          errorCells['trackingNumber'] = 'danger';
          errorCells['createDate'] = 'danger';
          errorCells['update'] = 'danger';
          errorCells['delete'] = 'danger';
        }
        v['_cellVariants'] = errorCells;
      }
    },
    outputCsv() {
      let csv = '\ufeff' + '請求日,請求額,追跡番号,LAS登録日,会員番号,会員名,登録日\n';
      let ids = [ 'customBillingDate', 'customs', 'trackingNumber', 'lasRegisteredDate', 'memberId', 'name', 'createDate' ];
      let fileName = '';
      for (const item of this.filteredItems) {
        csv = csv + '"';
        for (const id of ids) {
          if(item[id] == null || item[id] === ''){
            csv += '-","';
          } else{
            if(isNaN(item[id])){
              csv += item[id].replace(/"/g, '') + '","';
            } else{
              csv += item[id] + '","';
            }
          }
        }
        csv = csv.substring(0, csv.length - 2);
        csv += '\n';
      }
      fileName = 'customlist.csv';
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
};

Vue.component('inbound-slc-analysis', InboundSlcAnalysis);
Vue.component('date-picker', DatePicker);

</script>

<style>
.component-margin-half {
  margin-bottom: .5rem;
}
.component-margin {
  margin-bottom: 1rem;
}
.zoom-back-0{
  z-index: 0;
}
.zoom-back-1{
  z-index: 1;
}
@media (min-width: 768px) {
  .table-right  { text-align:right!important; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right!important; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left!important; }
}
</style>
